import { getAllOpModule, getAccessApp } from '@/api/system/oplog'

/** ************************************** 工具方法区 *****************************************/
/**
 * 封装完善子级分类的方法
 * @param {obj} parentObj 父级分类对象
 * @param {obj} moduleList 分类模块数据(list或array)
 */
function completeChildren(parentObj, moduleList) {
  const children = []
  // 1.筛选出符合条件的子分类
  for (const item of moduleList) {
    if (item.parentModuleCode === parentObj.moduleCode) {
      children.push(item)
    }
  }
  // 2.如果子分类存在,则封装属性
  if (children.length > 0) {
    // 递归封装子分类中的子子分类
    for (const item of children) {
      completeChildren(item, moduleList)
    }
    parentObj.children = children
  }
  // 3.返回封装后的parentObj对象
  return parentObj
}

/** ************************************** vuex属性区 *****************************************/

const state = {
  opModuleMap: null,
  accessAppTags: null
}

const mutations = {
  SET_OP_MODULE_MAP: (state, opModuleMap) => {
    state.opModuleMap = opModuleMap
  },
  SET_ACCESS_APP_TAGS: (state, appTags) => {
    state.accessAppTags = appTags
  }
}

const actions = {
  // 初始化权限过滤参数的方法
  async initAccessAppTags({ commit, state, rootState }) {
    return new Promise((resolve, reject) => {
      // 1.调用方法去获取当前租户可访问的应用信息
      getAccessApp().then(response => {
        const appInfos = response.data.data
        const appTags = []
        for (const appInfo of appInfos) {
          appTags.push(appInfo.appTag)
        }
        // 2.设置到vuex中
        commit('SET_ACCESS_APP_TAGS', appTags)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 初始化操作模块子父级映射map的方法
  async initOpModuleMap({ commit, dispatch, state, rootState }) {
    // 如果权限过滤参数还未初始化,就调用初始化方法初始化权限过滤参数
    if (!state.accessAppTags) {
      await dispatch('initAccessAppTags')
    }
    return new Promise((resolve, reject) => {
      getAllOpModule().then(response => {
        const moduleList = response.data.data
        // 1.先找到最大的顶级父类
        let parentObj = null
        for (const module of moduleList) {
          // 顶级父类的唯一数字标识码为99999
          if (module.moduleCode === 99999) {
            parentObj = module
            break
          }
        }
        // 2.再调用工具类方法,将list转为树形结构,封装到入参parentObj中
        completeChildren(parentObj, moduleList)
        // 3.根据应用权限,提取树形结构中的数据，封装成map,缓存到vuex中
        const accessAppTags = state.accessAppTags
        const opModuleMap = new Map()
        for (const module of parentObj.children) {
          // 4.根据权限过滤:比如accessAppTags = ['aicc-bp', 'aicc-icall', 'aicc-crm'],没有['aicc-order']则此处可以过滤掉
          if (accessAppTags.indexOf(module.appTag) > -1) {
            opModuleMap.set(module.moduleCode, module)
          }
        }
        // 5.缓存至vuex
        commit('SET_OP_MODULE_MAP', opModuleMap)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
